import type { ReactNode } from "react";
import { cn } from "../../ui/index.js";

/** Dense section frame for the Control Room rails. Tighter than the classic
 *  `Card` — a small uppercase header label, optional right-aligned action,
 *  and a flush body. Designed to stack several to a column without wasting
 *  vertical space. */
type Props = {
  label?: ReactNode;
  action?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
};

export function Panel({ label, action, className, bodyClassName, children }: Props) {
  return (
    <section
      data-anchor={typeof label === "string" ? `panel:${label}` : undefined}
      className={cn("flex flex-col rounded-lg border border-border bg-surface-muted/50", className)}
    >
      {(label || action) && (
        <header className="flex items-center justify-between gap-2 px-3 pt-2.5 pb-1.5">
          {label && (
            <h3 className="text-[10.5px] font-semibold uppercase tracking-[0.1em] text-ink-muted">
              {label}
            </h3>
          )}
          {action}
        </header>
      )}
      <div className={cn("px-3 pb-3", !label && "pt-3", bodyClassName)}>{children}</div>
    </section>
  );
}
